<template>
  <div class="center">
    <h1>{{ msg }}</h1>
    <br><br>

  
   
        <br><br>
  
  </div>
</template>

<script>


export default {
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.5rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}

.form__input {
  font-family: 'Roboto', sans-serif;
  color: rgb(85, 85, 204);
  font-size: 1.8rem;
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  background-color: rgb(40, 40, 53);
  border: none;
  width: 20%;
  display: block;
  border-bottom: 0.3rem solid transparent;
  transition: all 0.3s;
  text-align: center;
}



.form__input:placeholder-shown + .form__label {
  opacity: 0;
  visibility: hidden;
  -webkit-transform: translateY(-4rem);
  transform: translateY(-4rem);
}

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
  font-size: 62,5%;
}
.font_12{
  font-size: 1.8em;
    font-family: sans-serif;
}


.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 80%;
  margin-top: 30px;
  display: block;
  font-size: medium;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
  align-items: center;
}


.form__label {
  font-family: 'Roboto', sans-serif;
  font-size: 1.2rem;
  margin-left: 2rem;
  margin-top: 0.7rem;
  display: block;
  transition: all 0.3s;
  transform: translateY(0rem);
}


.center {
    
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    text-align: center;
}


</style>
